// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__eW70Z","textarea":"MessageSender_textarea__VTJEy","button":"MessageSender_button__LoTSs"};